/*
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */

import * as coreHttp from "@azure/core-http";
import * as Models from "../models";
import * as Mappers from "../models/apiVersionsMappers";
import * as Parameters from "../models/parameters";
import { MicrosoftConsumerSecurityClientContext } from "../microsoftConsumerSecurityClientContext";

/** Class representing a ApiVersions. */
export class ApiVersions {
  private readonly client: MicrosoftConsumerSecurityClientContext;

  /**
   * Create a ApiVersions.
   * @param {MicrosoftConsumerSecurityClientContext} client Reference to the service client.
   */
  constructor(client: MicrosoftConsumerSecurityClientContext) {
    this.client = client;
  }

  /**
   * Lists the supported API versions for the Portal service to serve as a quick reference.
   * @summary Returns the supported API versions across all endpoints for the Portal service.
   * @param [options] The optional parameters
   * @returns Promise<Models.ApiVersionsGetApiVersionsResponse>
   */
  getApiVersions(options?: coreHttp.RequestOptionsBase): Promise<Models.ApiVersionsGetApiVersionsResponse>;
  /**
   * @param callback The callback
   */
  getApiVersions(callback: coreHttp.ServiceCallback<Models.ApiVersionData[]>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  getApiVersions(options: coreHttp.RequestOptionsBase, callback: coreHttp.ServiceCallback<Models.ApiVersionData[]>): void;
  getApiVersions(options?: coreHttp.RequestOptionsBase | coreHttp.ServiceCallback<Models.ApiVersionData[]>, callback?: coreHttp.ServiceCallback<Models.ApiVersionData[]>): Promise<Models.ApiVersionsGetApiVersionsResponse> {
    return this.client.sendOperationRequest(
      {
        options
      },
      getApiVersionsOperationSpec,
      callback) as Promise<Models.ApiVersionsGetApiVersionsResponse>;
  }
}

// Operation Specifications
const serializer = new coreHttp.Serializer(Mappers);
const getApiVersionsOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "GET",
  path: "api/versions",
  queryParameters: [
    Parameters.apiVersion
  ],
  responses: {
    200: {
      bodyMapper: {
        serializedName: "parsedResponse",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "ApiVersionData"
            }
          }
        }
      }
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};
